import {isMobile, settingsData, threeJsVariables} from '../../settings';
import { Audio, AudioListener, AudioLoader } from 'three';
import { lazyLoadingData } from '../../functions';
import {stopCameraTour} from "../camera-auto-tour/cameraTour";

let hover, click, menu, backgroundSound, backgroundMixer, hoverMixer, menuMixer, clickMixer;

export function audioInit () {
  const listener = new AudioListener();

  threeJsVariables.perspectiveCamera.add(listener);

  const audioLoader = new AudioLoader();

  backgroundMixer = new Audio(listener);
  hoverMixer = new Audio(listener);
  menuMixer = new Audio(listener);
  clickMixer = new Audio(listener);

  hover = lazyLoadingData(audioLoader,'audio/hover_menu.mp3');
  click = lazyLoadingData(audioLoader,'audio/click.mp3');
  menu = lazyLoadingData(audioLoader,'audio/generic_transition.mp3');
  // backgroundSound = lazyLoadingData(audioLoader,'audio/Knowing.mp3');
}

export function backgroundSoundInit () {
  if (isAudioEnabled()){
    backgroundSound.then(file=>{
      backgroundMixer.setBuffer(file);
      backgroundMixer.setLoop(true);
      backgroundMixer.play();
    });
  }
}

export function clickAudio () {
  if (isAudioEnabled()){
    click.then(file =>{
      if (!clickMixer.isPlaying){
        clickMixer.setBuffer(file);
        clickMixer.duration = 0.4;
        clickMixer.play();
      }
    });
  }
}

export function hoverAudio () {
  if (isAudioEnabled()){
    hover.then(file =>{
      if (!hoverMixer.isPlaying){
        hoverMixer.setBuffer(file);
        hoverMixer.duration = 0.1;
        hoverMixer.play();
      }
    });
  }
}

export function menuAudio () {
  if (isAudioEnabled()){
   menu.then(file=>{
     if (!menuMixer.isPlaying){
       menuMixer.setBuffer(file);
       menuMixer.duration = 0.4;
       menuMixer.play();
     }
   });
  }
}

export function muteToggle () {
  if (settingsData.tourIsActive) {
    stopCameraTour();
  }
  const bgMusic = document.getElementsByClassName('background-music')[0];
  const soundBtn = document.querySelector('.aside__sound__btn');

  switch (soundBtn.dataset.active) {
    case 'on':
        soundBtn.dataset.active = 'off';
        bgMusic && bgMusic.play();
        settingsData.isSound = true;
        for (let child of soundBtn.children){
          child.connectedTrigger.leave();
        }
        // backgroundMixer.pause();
        // backgroundMixer.disconnect();
      break;
    case 'off':
        soundBtn.dataset.active = 'on';
        bgMusic && bgMusic.pause();
        settingsData.isSound = false;
        for (let child of soundBtn.children){
          child.connectedTrigger.leave();
        }
        // if (backgroundMixer._connected){
        //   backgroundMixer.play();
        // } else {
        //   backgroundSoundInit();
        // }
      break;
  }
}

function isAudioEnabled () {
 // return Boolean (document.querySelector('.aside__sound__btn[data-active="on"]'));
  return settingsData.isSound;
}


